export const SET_DOCUMENTS = '[Documents] Set documents';
export const SET_DOCUMENTS_ERROR = '[Documents] Set documents error';
export const DOCUMENT_TYPE_BOOKLET = 'Booklet';
export const DOCUMENT_TYPE_LETTER = 'Letter';
